import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import Link from '@material-ui/core/Link'
import { makeStyles } from '@material-ui/core/styles'
import { useReturnTo } from '../../lib/return-to'
import { API_HOST } from '../../env'

const useStyles = makeStyles(() => ({
  link: {
    fontWeight: 500,
  },
}))

const internalLink = (to, defaultLabel) => ({ children, ...linkProps }) => {
  const classes = useStyles()
  const className = `${classes.link} ${linkProps.className || ''}`
  return <Link {...linkProps} className={className} component={RouterLink} to={to}>{children || defaultLabel}</Link>
}

const internalButtonLink = (to, defaultLabel) => ({ children, ...buttonProps }) => {
  return <Button {...buttonProps} component={RouterLink} to={to}>{children || defaultLabel}</Button>
}

const ConsumerLoginLink = internalLink('/login', 'Log In')
const ConsumerSignUpLink = internalLink('/', 'Sign Up')
const ConsumerForgotPasswordLink = internalLink('/forgot-password', 'Forgot Password?')

const ConsumerLoginButton = internalButtonLink('/login', 'Log In')

const PGAMemberLoginLink = ({ children, ...linkProps }) => {
  const classes = useStyles()
  const className = `${classes.link} ${linkProps.className || ''}`
  const returnTo = useReturnTo()
  const qs = returnTo ? `?return_to=${encodeURIComponent(returnTo)}` : ''
  return <Link {...linkProps} className={className} href={`${API_HOST}/v2/login${qs}`}>{children || 'PGA Member Login'}</Link>
}

const CurrentUserLoginButton = (props) => {
  const { children, ...buttonProps } = props
  const returnTo = useReturnTo()
  return <Button {...buttonProps} href={returnTo || 'https://www.pga.com'}>{children || 'Log In'}</Button>
}

const CurrentUserLogoutLink = ({ currentUser, children, ...linkProps }) => {
  const classes = useStyles()
  const className = `${classes.link} ${linkProps.className || ''}`
  const returnTo = useReturnTo()
  const qs = returnTo ? `?return_to=${encodeURIComponent(returnTo)}` : ''
  const signOutRedirect = encodeURIComponent(`${window.location.origin}${qs}`)
  const logoutUrl = currentUser.role === 'COACH' ? `${API_HOST}/v2/logout` : `${API_HOST}/consumer/v1/logout`
  return <Link {...linkProps} className={className} href={`${logoutUrl}?return_to=${signOutRedirect}`}>{children}</Link>
}

// "login" for the mobile app means sending an interop message
// to close the webview that opened this page
const MobileAppLoginButton = ({ children, ...buttonProps }) => {
  // eslint-disable-next-line no-undef
  const onClick = () => FlutterWebview && FlutterWebview.postMessage('close')
  return <Button {...buttonProps} onClick={onClick}>{children}</Button>
}

export {
  ConsumerLoginLink,
  ConsumerSignUpLink,
  ConsumerForgotPasswordLink,
  ConsumerLoginButton,
  PGAMemberLoginLink,
  CurrentUserLoginButton,
  CurrentUserLogoutLink,
  MobileAppLoginButton,
}
